import { useFilterLeaveCategoryContext } from "./filter-leave-category.context";

export function FilterLeaveCategory() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterLeaveCategoryContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}